import { LuSearch } from "@/Components/Icons/Icons";
import {
  statusOptions,
  filling,
  JobNo,
  Active,
  taskTypeOptions
} from "@/Constant/Export/Dashboard/FilterBox";
import {
  transportModeFilter,
  customsHouseFilter,
  sbTypeOptions,
  
} from "@/Constant/Common/Common.jsx";


export default {
  row1: [
    {
      column: "column1",
      columnWidth: "100%",
      rows: {
        row1: [
          {
            name: "CommonSearch",
            placeholder: "Search Jobs",
            component: "text-field",
            width: "70%",
            startIconName: LuSearch,
            iconColor: "gray-300",
            gap: false,
            sx:{
              mt: 0.7,
              ml:1
            },
          },
          {
            name: "dateRange",
            component: "daterangeselector",
            width: "30%",
            sx: {
              mt: 1.4,
            },
            gap: false,
            maxDateToToday: true,
          },
          {
            name: "Advanced Filters",
            label: "Advanced Filters",
            component: "outlinebutton",
            iconName: "LuSlidersVertical",
            width: "20%",
            action: "toggleAdvanced",
            sx: {
              mt: 1.4,
              mr:2,
              flexGrow: 1,
              backgroundColor: "var(--gray-0)",
              borderColor: "var(--brand-600)",
              whiteSpace: "nowrap", 
              overflow: "hidden",
              textOverflow: "ellipsis",
              minWidth: "fit-content",
              maxWidth: "100%", 
              padding: "0 12px", 
              "& .MuiButton-label": {
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                width: "100%",
                overflow: "hidden",
              },
              "& .MuiButton-startIcon": {
                margin: 0, 
                flexShrink: 0, 
              },
            },
          },
        ],
        row2: [
            {
              name: "task",
              component: "dropdown",
              width: "20%",
              placeholder: "Select Task",
              endIconName: "LuChevronDown",
              startIconName: "MdTaskAlt",
              // value:"Job No",
              gap: false, // ✅ numeric gap works
              options: taskTypeOptions,
              sx:{mt:0.5}

            },
            {
              name: "jobNumber",
              component: "text-field",
              width: "25%",
              // placeholder: jobPlaceholder, // ✅ dynamic placeholder
              gap: false,
              sx: { mt: 0.5 },
            },
            
        ],
        row3: [
          {
            name: "JobFillingMode",
            label: "Filling mode",
            component: "dropdown",
            width: "17%",
            endIconName: "LuChevronDown",
            options: filling,
            placeholder:"Select Filling mode"
          },
          {
            name: "TransportMode",
            label: "Mode",
            component: "dropdown",
            width: "15%",
            endIconName: "LuChevronDown",
            options: transportModeFilter,
            placeholder:"Select Mode"
          },
          {
            name: "exporterName",
            label: "Exporter",
            component: "text-field",
            width: "30%",
            icon: LuSearch,
            type: "autocomplete",
            endpoint: "getCustomers",
            placeholder:"Select Exporter"
          },
          {
            name: "CustomHouse",
            label: "Customs House",
            component: "dropdown",
            width: "30%",
            endIconName: "LuChevronDown",
            options: customsHouseFilter.all,
            placeholder:"Select Customs House"

          },
        ],
        row4: [
          {
            name: "LoadingPort",
            label: "Loading Port",
            component: "text-field",
            width: "21%",
            type: "autocomplete",
            endpoint: "getGateway",
            useParams : "general.exportTransportMode",
            endpointWithParams : "portType",
            icon: LuSearch,
            placeholder:"Select Loading Port"
          },
          {
            name: "DestinationPort",
            label: "Destination Port",
            component: "text-field",
            width: "24%",
            icon: LuSearch,
            type: "autocomplete",
            endpoint: "getPorts",
            useParams : "general.exportTransportMode",
            endpointWithParams : "portType",
            placeholder:"Select Destination Port"
          },
          {
            name: "SBType",
            label: "S/B Type",
            component: "dropdown",
            width: "15%",
            endIconName: "LuChevronDown",
            options: sbTypeOptions,
            placeholder:"Select S/B Type"
            
          },
          {
            name: "Active",
            label: "Active",
            component: "dropdown",
            width: "15%",
            endIconName: "LuChevronDown",
            options: Active,
            placeholder:"Select Active"

          },
          {
            name: "Status",
            label: "Status",
            component: "dropdown",
            width: "15%",
            endIconName: "LuChevronDown",
            options: statusOptions,
            placeholder:"Select Status"

          },
        ],
        row5:[
          {
          name:"line",
          component:"hr"
        },
      ],
        row6: [
          {
            name: "Clear",
            component: "outlinebutton",
            label: "Clear",
            action: "closeAdvanced",
            width: "10%",
            sx: {
              display: "flex",
              justifyContent: "center", // right align
              ml: "auto", // alternative way
            },
          },
          {
            name: "search",
            component: "blackbutton",
            label: "Search",
            action: "search",
          
          },
        ],
      },
    },
  ],
};


